import React, { useEffect, useState } from "react";
import { Container, Boxs, Table } from "./styles";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { MdVisibility, MdDelete, MdEdit, MdLink } from "react-icons/md";
import { useAuth } from "../../../hooks/AuthContext";
import { format } from "date-fns";
import { useQuery } from "../../../hooks/Location";
import { Button, Input, Pagination, Spin, Modal } from "antd";
import { Card, Message, ViewInput } from "../../../GlobalStyles";
import Status from "../../../components/status";
import copy from "copy-to-clipboard";

import { ExclamationCircleFilled } from "@ant-design/icons";
import CountUp from "react-countup";
const { confirm } = Modal;

export default function Contracts() {
  const { user } = useAuth();

  const query = useQuery();
  const lead = query.get("lead");
  const name = query.get("name");

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");
  const [status, setStatus] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const [page, setPage] = useState(0);
  const [contracts, setContracts] = useState([]);
  const [totalContracts, setTotalContracts] = useState(0);
  const [infosContracts, setInfosContracts] = useState({});

  useEffect(() => {
    if (user.type == "tecnico") {
      navigate(-1);
    } else {
      if (user.restricted) {
        toast.warn("Área restrita para franqueados");
        navigate(-1);
      } else {
        listContracts(page, filterSearch, status);
      }
    }
  }, [page, filterSearch, status]);

  async function listContracts(page, search, status) {
    setLoading(true);
    let url = `/contracts?page=${page}`;
    if (search) {
      url += `&search=${search}`;
    }
    if (lead) {
      url += `&lead_id=${lead}`;
    }
    if (status) {
      url += `&status=${status}`;
    }
    await api
      .get(url)
      .then((response) => {
        setContracts(response.data.contracts);
        setTotalContracts(response.data.totalContracts);
        setInfosContracts(response.data.infosContracts);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function deleteContract(id) {
    await api
      .delete(`/contract/${id}`)
      .then(() => {
        toast.success("Contrato excluido com sucesso");
        listContracts(0, "", status);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  return (
    <Container>
      <h1>Contratos {name ? `(${name})` : ""}</h1>
      <Card>
        <p>Total</p>
        <CountUp duration={1} end={contracts.length} />
      </Card>
      <Boxs>
        <div
          style={{ background: "#46E961" }}
          className={status == "assinado" ? "active" : ""}
          onClick={() => {
            if (status == "assinado") {
              setStatus("");
            } else {
              setStatus("assinado");
            }
          }}
        >
          <p>Assinados {infosContracts?.totalContractsSigned || 0}</p>
        </div>
        <div
          style={{ background: "#46ADE9" }}
          className={status == "aguardando" ? "active" : ""}
          onClick={() => {
            if (status == "aguardando") {
              setStatus("");
            } else {
              setStatus("aguardando");
            }
          }}
        >
          <p>Aguardando {infosContracts?.totalContractsPedding || 0}</p>
        </div>
        <div
          style={{ background: "#FFBB45" }}
          className={status == "negociacao" ? "active" : ""}
          onClick={() => {
            if (status == "negociacao") {
              setStatus("");
            } else {
              setStatus("negociacao");
            }
          }}
        >
          <p>Em Negociação {infosContracts?.totalContractsNegotion || 0}</p>
        </div>
        <div
          style={{ background: "#9D9D9D" }}
          className={status == "expirado" ? "active" : ""}
          onClick={() => {
            if (status == "expirado") {
              setStatus("");
            } else {
              setStatus("expirado");
            }
          }}
        >
          <p>Expirados {infosContracts?.totalContractsExpired || 0}</p>
        </div>
        <div
          style={{ background: "#FF5D5D" }}
          className={status == "recusado" ? "active" : ""}
          onClick={() => {
            if (status == "recusado") {
              setStatus("");
            } else {
              setStatus("recusado");
            }
          }}
        >
          <p>Recusados {infosContracts?.totalContractsRecused || 0}</p>
        </div>
      </Boxs>
      <div className="filter">
        <ViewInput style={{ flex: 1, maxWidth: 350 }}>
          <p>Pesquisar</p>
          <Input.Search
            value={filter}
            onChange={(text) => {
              setFilter(text.target.value);
            }}
            placeholder="pesquisar"
            onSearch={(text) => {
              setFilterSearch(text);
              if (page) {
                setPage(0);
              } else {
                listContracts(0, filterSearch, status);
              }
            }}
            allowClear
            onClear={() => {
              setFilterSearch("");
              if (page) {
                setPage(0);
              }
              setFilter("");
            }}
            enterButton
          />
        </ViewInput>
        <Button
          type="primary"
          style={{
            marginTop: 17,
            marginLeft: 50,
            borderRadius: 50,
            marginRight: 15,
          }}
          onClick={() => {
            navigate(`/new-contract${lead ? `?lead=${lead}` : ""}`);
          }}
        >
          Novo Contrato
        </Button>
      </div>
      {loading ? (
        <Spin size="large" style={{ marginTop: 50 }} />
      ) : (
        <>
          {contracts.length == 0 ? (
            <Message>Nenhum contrato encontrado</Message>
          ) : (
            <Table>
              <thead>
                <tr>
                  <td>Razão Social</td>
                  <td>Telefone</td>
                  <td>Status</td>
                  <td>Data de Criação</td>
                  <td style={{ width: 150 }}>Ações</td>
                </tr>
              </thead>
              <tbody>
                {contracts.map((item) => {
                  return (
                    <tr key={item.id}>
                      <td>{item.name}</td>
                      <td style={{ textTransform: "capitalize" }}>
                        {item.phone_number}
                      </td>
                      <td>
                        <Status
                          status={item.status}
                          isPayment={false}
                          style={{
                            fontSize: 11,
                            height: 20,
                            paddingBottom: 2,
                          }}
                        />
                      </td>
                      <td>
                        {format(new Date(item.update_at), "dd/MM/yyyy HH:mm")}
                      </td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent:
                              item.status != "assinado"
                                ? "space-between"
                                : "space-evenly",
                          }}
                        >
                          <MdVisibility
                            color="#000"
                            size={20}
                            onClick={() => {
                              navigate(`/contract/${item.id}`);
                            }}
                            style={{
                              cursor: "pointer",
                            }}
                          />
                          <MdLink
                            color="#000"
                            size={20}
                            onClick={() => {
                              copy(
                                `https://app.gurusegead.com.br/contract/${item.id}`
                              );
                              toast.success(
                                "Link do contrado copiado com sucesso, envie para cliente"
                              );
                            }}
                            style={{
                              cursor: "pointer",
                            }}
                          />
                          {item.status != "assinado" && (
                            <MdEdit
                              color="#000"
                              size={20}
                              onClick={() => {
                                navigate(`/edit-contract/${item.id}`);
                              }}
                              style={{
                                cursor: "pointer",
                              }}
                            />
                          )}
                          {item.status != "assinado" && (
                            <MdDelete
                              color="#000"
                              size={20}
                              onClick={() => {
                                confirm({
                                  okText: "Confirmar",
                                  title: `Deseja excluir o contrato de ${item.name}?`,
                                  icon: <ExclamationCircleFilled />,
                                  content: `Após confirmação o contrato será excluido`,
                                  onOk() {
                                    deleteContract(item.id);
                                  },
                                  onCancel() {},
                                  cancelText: "Cancelar",
                                });
                              }}
                              style={{
                                cursor: "pointer",
                              }}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </>
      )}
      <Pagination
        style={{
          margin: "25px 0",
          alignSelf: "center",
        }}
        defaultCurrent={page + 1}
        pageSize={30}
        onChange={(page) => {
          setPage(page - 1);
        }}
        total={totalContracts}
      />
    </Container>
  );
}
